import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

const AtlasV2OrganicTrafficSplineChart = () => {
  return <AtlasV2ComparableSplineChart indexName="traffic" fieldName="organicClicks" />;
};

export default AtlasV2OrganicTrafficSplineChart;
